import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Plus, Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-[#0077B6]";
const empty = { title: "", slug: "", excerpt: "", content: "", cover_image: "", is_published: true };

export default function AdminBlog() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/admin/blog").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/admin/blog/${editId}`, form);
      else await api.post("/admin/blog", form);
      toast.success("Kaydedildi");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div>
      <div className="flex justify-between mb-6 items-center">
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Blog</h1>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <button onClick={() => { setForm(empty); setEditId(null); setOpen(true); }} className="btn-primary"><Plus size={16}/> Yeni Yazı</button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader><DialogTitle>{editId ? "Yazıyı Düzenle" : "Yeni Yazı"}</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3">
              <input required placeholder="Başlık" className={inputCls} value={form.title} onChange={(e) => setForm({...form, title: e.target.value, slug: form.slug || e.target.value.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")})} />
              <input required placeholder="Slug" className={inputCls} value={form.slug} onChange={(e) => setForm({...form, slug: e.target.value})} />
              <input placeholder="Kapak görsel URL" className={inputCls} value={form.cover_image} onChange={(e) => setForm({...form, cover_image: e.target.value})} />
              <textarea placeholder="Özet" rows={2} className={inputCls} value={form.excerpt} onChange={(e) => setForm({...form, excerpt: e.target.value})} />
              <textarea required placeholder="İçerik" rows={8} className={inputCls} value={form.content} onChange={(e) => setForm({...form, content: e.target.value})} />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.is_published} onChange={(e) => setForm({...form, is_published: e.target.checked})} /> Yayında</label>
              <button className="btn-primary w-full">Kaydet</button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <div className="space-y-3">
        {list.map((p) => (
          <div key={p.id} className="bg-white rounded-2xl border border-slate-100 p-4 flex gap-4">
            {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-24 h-24 rounded-lg object-cover" />}
            <div className="flex-1">
              <div className="font-display font-bold">{p.title}</div>
              <div className="text-xs text-slate-500 mb-1">/{p.slug}</div>
              <div className="text-sm text-slate-600 line-clamp-2">{p.excerpt}</div>
            </div>
            <div className="flex flex-col gap-2">
              <button onClick={() => { setForm(p); setEditId(p.id); setOpen(true); }} className="text-[#0077B6]"><Edit size={15}/></button>
              <button onClick={async () => { if(window.confirm("Sil?")) { await api.delete(`/admin/blog/${p.id}`); load(); }}} className="text-rose-600"><Trash2 size={15}/></button>
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="bg-white rounded-2xl p-10 text-center text-slate-600">Yazı yok.</div>}
      </div>
    </div>
  );
}
